<template>
  <v-form class='my-2'
    v-model="detailMixin.valid"
    ref="formBouwmateriaal">
    <div
      v-if="detailMixin.element && detailMixin.element.multicheck && detailMixin.element.fields"
      :class="DetailMixin_Dirty ? 'dirtyForm' : DetailMixin_Revertable && !detailMixin.element.isNew ? 'editForm' : ''"
      >
      <h2 class='primary--text'>Beschrijving van de gebruikte bouwmaterialen</h2>

      <div v-if="selectieControlTypes && selectieControlTypes.length">
        <control-multi-check :cols="3" radio :list="metselwerkTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[0].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[0].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="dakTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[1].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[1].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="dakbedekkingTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[2].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[2].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="schrijnwerkTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[3].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[3].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="beglazingTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[4].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[4].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" radio :list="isolatieTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[5].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[5].langeBeschrijving"/>
      </div>
      <v-divider class="mb-5"></v-divider>

      <h3 class="secondary--text my-3">Overige</h3>
      <v-row class="pb-0">
        <v-col cols="12">
          <v-row class="pb-0">
              <v-col cols="12" md="4">
              <v-textarea label="Funderingen" auto-grow outlined v-model="detailMixin.element.fields.funderingen"/>
              </v-col>
              <v-col cols="12" md="4">
              <v-textarea label="Vloeren" auto-grow outlined v-model="detailMixin.element.fields.vloeren"/>
              </v-col>
              <v-col cols="12" md="4">
              <v-textarea label="Afwerking" auto-grow outlined v-model="detailMixin.element.fields.afwerking"/>
              </v-col>
              <v-col cols="12" md="4">
                <control-number label="EPC-score (kWh/m²/jaar)" :decimals="0" v-model="detailMixin.element.fields.epcScore"/>
              </v-col>
              <v-col cols="12" md="2">
                <control-select
                  :items="epcLabelList"
                  label="EPC-label"
                  v-model="detailMixin.element.fields.idCodeEpcLabel"
                  :itemValue="'idCode'"
                  :itemText="'langeBeschrijving'"/>
              </v-col>
              <v-col cols="12" md="3">
                <control-select
                  :items="elektriciteitConformList"
                  label="Elektriciteit"
                  v-model="detailMixin.element.fields.idCodeElectriciteitConform"
                  :itemValue="'idCode'"
                  :itemText="'langeBeschrijving'"
                />
              </v-col>
              <v-col cols="12" md="3">
                <control-select
                  :items="asbestInventarisList"
                  label="Asbest inventaris"
                  v-model="detailMixin.element.fields.idCodeAsbestInventaris"
                  :itemValue="'idCode'"
                  :itemText="'langeBeschrijving'"
                />
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider class="mb-5 mt-10"></v-divider>

      <h3 class="secondary--text my-3">Bijlage</h3>
      <v-row class="pb-0">
        <v-col cols="12" md="6">
          <control-file-input-drag-and-drop v-model="detailMixin.element.files" @download="Download($event)" :accept="['.png', '.jpg', '.jpeg', '.gif']"/>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import blobMixin from '../../mixins/blobMixin'
import commonMixin from '../../mixins/commonMixin'
import detailMixin from '../../mixins/detailMixin'
import errorMixin from '../../mixins/errorMixin'
import codeService from '../../services/codeService'
import schattingService from '../../services/schattingService'
import ControlFileInputDragAndDrop from '../ControlFileInputDragAndDrop.vue'
import ControlMultiCheck from '../ControlMultiCheck.vue'
import ControlNumber from '../ControlNumber.vue'
import ControlSelect from '../ControlSelect.vue'
import offlineStorage from '@/utils/offlineStorage'
import networkStatus from '@/utils/networkStatus'
import { debounce } from 'lodash'

export default {
  components: {
    ControlFileInputDragAndDrop,
    ControlMultiCheck,
    ControlNumber,
    ControlSelect
  },
  mixins: [
    errorMixin,
    commonMixin,
    detailMixin,
    blobMixin
  ],
  props: {
    idSchatting: {
      default: null,
      type: String
    },
    visible: Boolean
  },
  data () {
    return {
      referentieType: '0b197cc7-144e-4684-a1e3-6f2c07c21238',
      metselwerkTypes: null,
      dakTypes: null,
      dakbedekkingTypes: null,
      schrijnwerkTypes: null,
      beglazingTypes: null,
      isolatieTypes: null,
      selectieControlTypes: {},
      elektriciteitConformList: [],
      asbestInventarisList: [],
      epcLabelList: []
    }
  },
  mounted () {
    codeService.Init(this)
    this.initAutoSave()
  },
  watch: {
    async visible () {
      if (this.visible) {
        await this.SetVariables()
        await this.loadEverything()
        await this.SetSelectionList()
      } else if (this.DetailMixin_Dirty) {
        this.DetailMixin_Save()
      }
    },
    // Deep watch for automatic caching of afmetingen data
    'detailMixin.element.multicheck': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    },
    'detailMixin.element.fields': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    }
  },
  methods: {
    initAutoSave () {
      // Create a debounced version of the auto-save function
      // This will wait 1 second after the last change before saving
      this.debouncedAutoSave = debounce(this.autoSaveToCache, 1000)
    },
    async autoSaveToCache () {
      const id = this.DetailMixin_GetId()
      if (!id || !this.detailMixin.element?.fields || !this.detailMixin.element?.multicheck) return

      try {
        await offlineStorage.saveSchattingStep('bouwmateriaal', id, this.detailMixin.element.fields)
        await offlineStorage.saveSchattingStep('bouwmateriaalCodeSelecties', id, this.detailMixin.element.multicheck)
        this.CommonMixin_Snackbar('Aanpassing lokaal opgeslagen', 'success')
      } catch (error) {
        console.error('Auto-save to cache failed:', error)
        this.CommonMixin_Snackbar('Automatisch opslaan mislukt', 'error')

        // Clear the error message after 3 seconds
        setTimeout(() => {
          if (this.autoSaveStatus === 'error') {
            this.autoSaveStatus = null
            this.autoSaveMessage = ''
          }
        }, 3000)
      }
    },
    Download (blob) {
      const blobFormatted = this.CommonMixin_Clone(blob)
      blobFormatted.bestandsnaam = blob.name
      this.BlobMixin_Download(blobFormatted)
    },
    async loadEverything () {
      this.CommonMixin_Load(this.$options.name, true)
      await this.SetMetselwerkTypes()
      await this.SetDakTypes()
      await this.SetDakbedekkingTypes()
      await this.SetSchrijnwerkTypes()
      await this.SetBeglazingTypes()
      await this.SetIsolatieTypes()
      await this.SetSelectieControlTypes()
      await this.GetElektriciteitConformList()
      await this.GetAsbestInventarisList()
      await this.GetEpcLabelList()
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetAsbestInventarisList () {
      const cachedAsbestInventarisList = await offlineStorage.getLookupData('asbestInventaris')
      if (cachedAsbestInventarisList) {
        this.asbestInventarisList = cachedAsbestInventarisList
      }
    },
    async GetElektriciteitConformList () {
      const cachedElektriciteitConformList = await offlineStorage.getLookupData('elektriciteitsConform')
      if (cachedElektriciteitConformList) {
        this.elektriciteitConformList = cachedElektriciteitConformList
      }
    },
    async GetEpcLabelList () {
      const cachedEpcLabelList = await offlineStorage.getLookupData('epcLabels')
      if (cachedEpcLabelList) {
        this.epcLabelList = cachedEpcLabelList
      }
    },
    async SetMetselwerkTypes () {
      const cachedMetselwerkTypes = await offlineStorage.getLookupData('metselwerkTypes')
      if (cachedMetselwerkTypes) {
        this.metselwerkTypes = cachedMetselwerkTypes
      }
    },
    async SetDakTypes () {
      const cachedDakTypes = await offlineStorage.getLookupData('dakTypes')
      if (cachedDakTypes) {
        this.dakTypes = cachedDakTypes
      }
    },
    async SetDakbedekkingTypes () {
      const cachedDakBedekkingTypes = await offlineStorage.getLookupData('dakBedekkingTypes')
      if (cachedDakBedekkingTypes) {
        this.dakbedekkingTypes = cachedDakBedekkingTypes
      }
    },
    async SetSchrijnwerkTypes () {
      const cachedSchrijnwerkTypes = await offlineStorage.getLookupData('schrijnwerkTypes')
      if (cachedSchrijnwerkTypes) {
        this.schrijnwerkTypes = cachedSchrijnwerkTypes
      }
    },
    async SetBeglazingTypes () {
      const cachedBeglazingTypes = await offlineStorage.getLookupData('beglazingTypes')
      if (cachedBeglazingTypes) {
        this.beglazingTypes = cachedBeglazingTypes
      }
    },
    async SetIsolatieTypes () {
      const cachedIsolatieTypes = await offlineStorage.getLookupData('isolatieTypes')
      if (cachedIsolatieTypes) {
        this.isolatieTypes = cachedIsolatieTypes
      }
    },
    async SetSelectionList () {
      const id = this.DetailMixin_GetId()

      if (id) {
        // const responseBouwmaterialenMulticheck = await codeService.GetCodeSelectie(id, this.referentieType)
        const responseBouwmaterialenMulticheck = await offlineStorage.getSchattingStep('bouwmateriaalCodeSelecties', id)
        var element = {
          multicheck: {},
          fields: {},
          files: []
        }

        if (responseBouwmaterialenMulticheck) {
          // Filter out offlineStorage metadata fields
          const { idSchatting, timestamp, syncStatus, ...multicheckData } = responseBouwmaterialenMulticheck
          element.multicheck = this.CommonMixin_Clone(multicheckData)
          this.$forceUpdate()
        }

        // const responseBouwmaterialen = await schattingService.GetBouwmateriaalByIdSchatting(id)
        const responseBouwmaterialen = await offlineStorage.getSchattingStep('bouwmateriaal', id)
        if (responseBouwmaterialen) {
          element.fields = this.CommonMixin_Clone(responseBouwmaterialen)
          this.$forceUpdate()
        }

        this.detailMixin.element = this.CommonMixin_Clone(element)

        if (networkStatus.isOnline()) {
          try {
            const files = await this.BlobMixin_GetFiles(this.idSchatting, this.referentieType)
            this.detailMixin.element.files = files
            this.$forceUpdate()
          } catch (error) {
            console.warn('Kon blobs niet ophalen:', error)
            if (!responseBouwmaterialen) {
              console.error('Geen cached data beschikbaar voor afmetingen')
            }
          }
        }

        this.DetailMixin_InitDirtyWatch()
      }
    },
    async SetSelectieControlTypes () {
      // const response = await codeService.GetSelectieControlTypes()
      const cachedSelectieControlTypes = await offlineStorage.getLookupData('selectieControlTypes')
      if (cachedSelectieControlTypes) {
        this.selectieControlTypes = cachedSelectieControlTypes.filter(x => x.waarde >= 400 && x.waarde <= 499)
      }
    },
    SetVariables () {
      this.detailMixin.key = 'id'
      this.detailMixin.rightsNeeded = ['admin', 'gebruiker']
      this.detailMixin.functions.validate = this.$refs.formBouwmateriaal.validate
      this.detailMixin.functions.save = this.save
    },
    async save (element) {
      var multicheck = await codeService.SaveMulticheck({ IdReferentie: this.idSchatting, IdCodeReferentieType: this.referentieType, MultiSelects: element.multicheck })
      var fields = await schattingService.UpdateSchattingBouwmateriaal(element.fields)
      await this.BlobMixin_SaveFiles(element.files, this.idSchatting, this.referentieType)
      var multicheckData = null
      var fieldsData = null
      if (multicheck && multicheck.data) {
        multicheckData = multicheck.data
      }
      if (fields && fields.data) {
        fieldsData = fields.data
      }
      return {
        data: {
          multicheck: multicheckData,
          fields: fieldsData
        }
      }
    },
    Validate () {
      this.$refs.formBouwmateriaal.validate()
      return this.detailMixin.valid
    }
  }
}
</script>
